module.exports = __webpack_public_path__ + "img/fiorentina.268ee21b.png";